import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { Notify, Dialog } from 'vant'
import vueTouch from "vue-plugin-touch"
import touch from 'vue-directive-touch'
import VueI18n from 'vue-i18n'
import 'lib-flexible'
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
import vueEsign from 'vue-esign'
import VModal from 'vue-js-modal'
import { Popup } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/pt-br.js';
// import VueFacebookPixel from 'vue-facebook-pixel';
// import fbPixel from 'vue-facebook-pixel'

Vue.use(Popup);
Vue.use(Notify).use(Dialog).use(vueTouch).use(touch).use(VueI18n).use(VueClipboard).use(vueEsign).use(VModal);
Vue.use(ElementUI, { locale });
Vue.use(VueLazyload, {
    preLoad: 1.3,  // proportion of pre-loading height, 个人理解是图片加载前目标元素位置范围  // 加载错误时
    loading: require('/src/assets/images/common/777.png'), // 加载中
    attempt: 1  // 下载图片时错误重连次数
})
// Vue.use(fbPixel, {
//     enabled: true, // 确保这个属性设置为true，如果你想要在所有环境中启用
//     config: {
//         // 你的Facebook像素ID
//         pixelId: '485010714168010',
//         // track: "PageView"
//         // 其他需要的配置
//     },
// });
// Vue.use(VueFacebookPixel);

import VueLazyload from 'vue-lazyload';


const i18n = new VueI18n({
    locale: localStorage.getItem("lang") || "pt_br",
    messages: {
        'pt_br': require('./assets/languages/pt_br.json'),
        'en_us': require('./assets/languages/en_US.json'),
        'zh_cn': require('./assets/languages/zh_cn.json'),
    }
});
Vue.config.productionTip = false;
// const fbPixel = new VueFacebookPixel({
//     track: 'PageView',
//     pixelId: '485010714168010' // 替换为你的 Facebook 像素ID
// });

window.vm = new Vue({
    beforeCreate() {
        // 尽量早地执行挂载全局事件总线对象的操作
        Vue.prototype.$bus = this;
    },
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');


